/* Progressive enhancement: native search and navigation work without this file. */
(() => {
  // Keep region labels in English while preserving the selected Shopify Market.
  const nameCountries = (root = document) => {
    if (!Intl.DisplayNames) return;
    const names = new Intl.DisplayNames(['en'], { type: 'region' });
    root.querySelectorAll('[data-country-names="en"] option').forEach((option) => {
      if (!/^[A-Z]{2}$/.test(option.value)) return;
      const currency = option.textContent.match(/\([^)]*\)\s*$/)?.[0] || '';
      option.textContent = `${names.of(option.value)} ${currency}`.trim();
    });
  };
  nameCountries();
  document.addEventListener('shopify:section:load', (event) => nameCountries(event.target));
  document.addEventListener('submit', (event) => {
    const form = event.target.closest('[data-model-finder]');
    if (!form) return;
    const selected = form.querySelector('select')?.selectedOptions[0];
    const destination = selected?.dataset.collectionUrl;
    if (!destination) return;
    const url = new URL(destination, window.location.origin);
    if (url.origin !== window.location.origin) return;
    event.preventDefault();
    window.location.assign(url.href);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openMenu = document.activeElement.closest('details[open]');
    if (openMenu?.matches('.nav-dropdown, .mobile-navigation')) {
      openMenu.open = false;
      openMenu.querySelector('summary')?.focus();
    }
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.nav-dropdown[open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
})();
